import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=70d0cd84&scoped=true&"
import script from "./CreateQuestion.vue?vue&type=script&lang=js&"
export * from "./CreateQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0cd84",
  null
  
)

export default component.exports